import React from "react";
import {FaLinkedin,FaEnvelope,FaBitbucket} from "react-icons/fa"

const Footer=()=>{
    return(
        // <footer className="bg-gray-100">
        //         <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-6">
        //                 <div className="justify-center">Bhavesh Hindocha</div>
        //         </div>
        // </footer>
        <footer className="pt-4 pb-4 text-center bg-light">
            <div className="container">
                <div className="my-3">
                <div className="h4">Bhavesh Hindocha</div>
                <p>Front-End Developer</p>
                <div className="social-nav">
                    <nav role="navigation">
                        {/* TODO: add link */}
                    <ul className="nav justify-content-center">
                    <a href="https://www.linkedin.com/in/bhavesh-hindocha-184739181" rel="noreferrer" target="_blank" className="px-2 text-black hover:text-cyan-500"><FaLinkedin size={30}/></a>
            <a href="mailto:bhavesh.hindocha.03@gmail.com" target="_blank" rel="noreferrer" className="px-2 text-black"><FaEnvelope size={30}/></a>
            <a href="https://bitbucket.org/Bhavesh2905/"  target="_blank" rel="noreferrer" className="px-2 text-black"><FaBitbucket size={30}/></a></ul>
                    </nav>
                </div>
            </div>
            <div className="text-small text-secondary">
                <div className="mb-1">&copy;2022 Bhavesh Hindocha .</div>
                 </div>
            </div>
        </footer>
    )
}

export default Footer;